export default __webpack_public_path__ + "static/media/commentIcon.b6cd1d04.svg";